module.exports = __webpack_public_path__ + "static/media/produtos_nao_localizados.9560ac3c.svg";